import { render } from "./App.vue?vue&type=template&id=75c4ef91&bindings={\"handleImageClick\":\"options\",\"calculateSurface\":\"options\",\"calculateOverallInsulation\":\"options\",\"surfaceCalculationError\":\"options\",\"insulationCalculationError\":\"options\",\"addParam\":\"options\",\"adjustRequestUrl\":\"options\",\"calculate\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script